var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuotationCreated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 6C23.5 9.31371 20.8137 12 17.5 12C14.1863 12 11.5 9.31371 11.5 6C11.5 2.68629 14.1863 0 17.5 0C20.8137 0 23.5 2.68629 23.5 6ZM16.5 2.27724C16.5 1.84798 16.8384 1.5 17.2557 1.5C17.6731 1.5 18.0115 1.84798 18.0115 2.27724V5.84147L20.2787 8.17318C20.5738 8.47671 20.5738 8.96882 20.2787 9.27235C19.9835 9.57588 19.505 9.57588 19.2099 9.27235L16.5 6.48535V2.27724ZM2.5 1H11.2546C10.7724 1.60158 10.3753 2.27434 10.0815 3H2.5V19H8.5V14C8.5 13.4477 8.94771 13 9.5 13H13.624C14.4942 13.4829 15.4639 13.8082 16.4946 13.9374C16.4507 14.6681 16.1408 15.3599 15.62 15.88L11.38 20.12C10.8179 20.6828 10.0554 20.9993 9.26 21H2.5C1.39543 21 0.5 20.1046 0.5 19V3C0.5 1.89543 1.39543 1 2.5 1ZM5 5H9.56189C9.52104 5.32759 9.5 5.66134 9.5 6C9.5 6.33866 9.52104 6.67241 9.56189 7H5C4.72386 7 4.5 6.77614 4.5 6.5V5.5C4.5 5.22386 4.72386 5 5 5ZM9 11H5C4.72386 11 4.5 10.7761 4.5 10.5V9.5C4.5 9.22386 4.72386 9 5 9H9C9.27614 9 9.5 9.22386 9.5 9.5V10.5C9.5 10.7761 9.27614 11 9 11Z",
    fill: "#62B5C6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotationCreated);
export default __webpack_public_path__ + "static/media/QuotationCreated.1be9160a72fdcc41278b97c44735212f.svg";
export { ForwardRef as ReactComponent };